export { TRACKING_KEYS, DEFAULT_CONFIG, DEFAULT_THEME } from './constants';
export {
  initializeTracking,
  getTrackingData,
  clearTrackingData,
  getUserContext,
} from './tracking';
export {
  initializeGTM,
  trackWidgetLoaded,
  trackChatStarted,
  trackLeadGenerated,
  trackFormFillingStarted,
  trackFormSubmitted,
  trackEnquirySubmitted,
  trackWidgetMessageSubmitted,
  isGTMEnabled,
  isGTMAvailable,
  getGTMState,
  resetGTMState,
} from './gtm';
export type {
  GTMConfig,
  GTMEventPayload,
  GTMEventName,
  GTMCapturedData,
} from './gtm';
export { zo } from './zod';
export type { UserContext, TrackingData } from '@peptalk/shared';
export * from './fields';
export * from './page-context';
export * from './date';
export * from './field-context-helpers';
export * from './scroll';
// Exported LAST: config.ts pulls the zod schema chain (@/types), which imports
// `zo` and field-context-helpers from this barrel. Keeping it after those
// exports ensures they're defined when the schemas evaluate (otherwise an entry
// that reaches config first — e.g. mcp-chat — sees them undefined and throws).
export { mergeConfig, generateThemeCSS } from './config';
